// src/hooks/useRole.ts
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types/chat';

export const useRole = () => {
  const { user } = useAuth();

  const hasRole = (roles: UserRole | UserRole[]): boolean => {
    if (!user) return false;
    
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(user.role);
  };

  const isGuest = user?.role === UserRole.GUEST;
  const isOperator = user?.role === UserRole.OPERATOR;
  const isAdmin = user?.role === UserRole.ADMIN;
  const isStaff = user?.role === UserRole.OPERATOR || user?.role === UserRole.ADMIN;

  return {
    hasRole,
    isGuest,
    isOperator,
    isAdmin,
    isStaff,
    userRole: user?.role,
  };
};

